// export function formatFields(fields, userLogin) {
//   const allowedRoles = ["Admin", "Manager"];

//   const isAdminOrManager = userLogin?.roles?.some((r) =>
//     allowedRoles.includes(r.id)
//   );
//   const { user, ...rest } = fields;

//   console.log("Rest", rest);

//   const baseFields = {
//     ...rest,
//   };

//   // Only add these fields if Admin
//   if (isAdminOrManager) {
//     baseFields.systemCounts = { type: "String", label: "System Count" };
//     baseFields.actualCounts = { type: "String", label: "Actual Count" };
//   }

//   return baseFields;
// }

// export function formatObjects(objects, userLogin) {
//   console.log("asasas", userLogin);
//   const allowedRoles = ["Admin", "Manager"];

//   const isAdminOrManager = userLogin?.roles?.some((r) =>
//     allowedRoles.includes(r.id)
//   );
//   console.log("isAdminOrManager", isAdminOrManager);

//   return objects.map((object) => {
//     const { ...rest } = object || {};
//     const base = {
//       ...rest,
//     };

//     // Only show counts if Admin
//     if (isAdminOrManager) {
//       base.systemCounts = formatNumber(object?.systemCount);
//       base.actualCounts = formatNumber(object?.actualCount);
//     }

//     return base;
//   });
// }

// export function formatNumber(value) {
//   if (value === null || value === undefined || value === "") {
//     return "N/A";
//   }

//   const num = parseFloat(value);

//   if (isNaN(num)) {
//     return "N/A";
//   }

//   // Format with commas and 2 decimal places
//   return num.toLocaleString("en-US", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });
// }

export function formatFields(fields, userLogin) {
  console.log("userLogin", userLogin);
  const allowedRoles = ["Admin", "Manager"];
  const AdminRoles = ["Admin"];

  const isAdminOrManager = userLogin?.roles?.some((r) =>
    allowedRoles.includes(r.id),
  );

  const isAdmin = userLogin?.roles?.some((r) => AdminRoles.includes(r.id));

  // console.log("is", isAdmin);

  const { user, ...rest } = fields;

  const baseFields = {};

  // console.log("base", baseFields);

  // Preserve order and insert stockAmount after cost
  Object.entries(rest).forEach(([key, value]) => {
    baseFields[key] = value;

    if (key === "cost" && isAdminOrManager) {
      baseFields.stockAmount = {
        type: "String",
        label: "Stock Amount",
      };
    }
  });

  // Only add these fields if Admin / Manager
  if (isAdminOrManager) {
    baseFields.systemCounts = { type: "String", label: "System Count" };
    baseFields.actualCounts = { type: "String", label: "Actual Count" };
  }

  if (isAdmin) {
    baseFields.storeId = {
      type: "Pointer",
      label: "Store",
    };
  }

  return baseFields;
}

export function formatObjects(objects, userLogin) {
  const allowedRoles = ["Admin", "Manager"];
  const AdminRoles = ["Admin"];

  const isAdminOrManager = userLogin?.roles?.some((r) =>
    allowedRoles.includes(r.id),
  );

  const isAdmin = userLogin?.roles?.some((r) => AdminRoles.includes(r.id));

  return objects.map((object) => {
    const base = {};

    Object.entries(object || {}).forEach(([key, value]) => {
      // ✅ FORMAT COST
      if (key === "cost") {
        base.cost = formatNumber(value);

        if (isAdminOrManager) {
          const cost = Number(value) || 0;
          const systemCount = Number(object?.systemCount) || 0;

          base.stockAmount = formatNumber(cost * systemCount);
        }

        return;
      }

      base[key] = value;
    });

    if (isAdminOrManager) {
      base.systemCounts = formatCount(object?.systemCount);
      base.actualCounts = formatCount(object?.actualCount);
    }

    return base;
  });
}

export function formatNumber(value) {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  const num = Number(value);

  if (Number.isNaN(num)) {
    return "N/A";
  }

  return num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCount(value) {
  if (value === null || value === undefined || value === "") {
    return "N/A";
  }

  const num = Number(value);

  if (Number.isNaN(num)) {
    return "N/A";
  }

  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
